import React, { useEffect, useState } from 'react'
import axios from 'axios'
import './index.css'

function App() {
  const [settings, setSettings] = useState(null)

  useEffect(() => {
    axios
      .get('/wp-json/crypto-screener/v1/my_settings', { withCredentials: true })
      .then(res => setSettings(res.data))
      .catch(err => console.error('Failed to fetch settings:', err))
  }, [])

  if (!settings) {
    return <div className="p-8">Loading your dashboard…</div>
  }

  const url = new URL('https://screener.forexpipsplus.com')
  if (settings.screener_timeframe)      url.searchParams.set('timeframe', settings.screener_timeframe)
  if (settings.screener_min_volume)     url.searchParams.set('min_volume', settings.screener_min_volume)
  if (settings.screener_min_gain)       url.searchParams.set('min_gain', settings.screener_min_gain)
  if (settings.screener_min_confidence) url.searchParams.set('min_confidence', settings.screener_min_confidence)

  return (
    <div className="flex h-screen">
      <aside className="w-72 p-4 bg-gray-100 border-r">
        <h2 className="text-lg font-semibold mb-4">Your Settings</h2>
        <ul className="text-sm space-y-2">
          <li><strong>Timeframe:</strong> {settings.screener_timeframe}</li>
          <li><strong>Min Volume:</strong> {settings.screener_min_volume}</li>
          <li><strong>Min Gain:</strong> {settings.screener_min_gain}</li>
          <li><strong>Min Confidence:</strong> {settings.screener_min_confidence}</li>
        </ul>
      </aside>
      <main className="flex-1">
        <iframe
          title="Crypto Screener"
          sandbox="allow-scripts allow-same-origin"
          src={url.toString()}
          className="w-full h-full border-0"
        />
      </main>
    </div>
  )
}

export default App

